import { render } from "./Paginador.vue?vue&type=template&id=6fcfe8c3"
import script from "./Paginador.vue?vue&type=script&lang=js"
export * from "./Paginador.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__